@use '@lib/assets/styles/main.scss' as *;
.actionHistoryView {
  background-color: $gray0;
  border-radius: 8px;
  overflow: hidden;
}

.actionHistoryViewHeader {
  display: grid;
  grid-gap: 8px;
  align-items: center;
  padding: 8px;
  @include responsive($md1) {
    grid-template-columns: auto min-content;
  }
  @include responsive(null, $md1) {
    grid-template-rows: auto min-content;
  }
}

.dateUpdated {
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    display: block;
    &:nth-child(1) {
      color: $gray400;
    }
    &:nth-child(2) {
      width: 1px;
      height: 16px;
      background-color: $gray100;
    }
    &:nth-child(3) {
      color: $gray500;
    }
  }
}

.actionHistoryViewBody {
  padding: 8px 8px 8px 40px;
  border-top: 1px solid $gray100;
  & > div + div {
    margin-top: 12px;
  }
}

.historyValues {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}

.historyValuesArrow {
  color: $gray500;
}

.historyValuesTitle {
  color: $gray400;
}

.timeValue {
  display: grid;
  grid-template-columns: min-content auto;
  align-items: center;
  grid-gap: 4px;
  white-space: nowrap;
}

.timeValueIcon {
  color: $gray400;
}

.infoIcon {
  color: $gray500;
  display: block;
  cursor: pointer;
}
